import moment from "moment-timezone";
import { convertToCompanyAndTitleName } from "../../services/utils";
import { concatSelectedFromToTime } from "../../services/utils/date-and-time.utils";

export type UpcomingMeetingNotificationItem = {
  ambassadorInvitationId?: string;
  isAmbassadorAttend?: boolean;
  client?: {
    firstName?: string;
    lastName?: string;
    company?: string;
    timezone?: {
      value?: string;
    };
  };
  selectedTimeSlot?: {
    from?: string | Date;
    to?: string | Date;
  };
};

export function getUpcomingMeetingDisplayName(
  meeting: UpcomingMeetingNotificationItem
) {
  return convertToCompanyAndTitleName(meeting?.client) || "Meeting";
}

export function getUpcomingMeetingTimeLabel(
  meeting: UpcomingMeetingNotificationItem,
  timezone?: string
) {
  const from = meeting?.selectedTimeSlot?.from;
  const to = meeting?.selectedTimeSlot?.to;

  if (!from) return "";

  if (to) {
    if (timezone) {
      const fromLabel = moment(from).tz(timezone).format("hh:mm A");
      const toLabel = moment(to).tz(timezone).format("hh:mm A");
      const dateLabel = moment(from).tz(timezone).format("ddd, MMM D");
      return `${dateLabel} · ${fromLabel} - ${toLabel}`;
    }

    return concatSelectedFromToTime({ from, to }, true);
  }

  const meetingMoment = timezone
    ? moment(from).tz(timezone)
    : moment(from);

  return meetingMoment.format("ddd, MMM D · hh:mm A");
}

export function getUpcomingMeetingInvitationId(
  meeting: UpcomingMeetingNotificationItem | null
) {
  return meeting?.ambassadorInvitationId;
}

export function getUnmarkedUpcomingMeetings(
  meetings: UpcomingMeetingNotificationItem[] = []
) {
  return meetings.filter((meeting) => !meeting?.isAmbassadorAttend);
}
